import { createContext, useContextSelector } from 'use-context-selector';

const LineItemContext = createContext(null);

export const useLineItem = () => useContextSelector(LineItemContext, lineItem => lineItem);
export const useLineItemField = alias => useContextSelector(LineItemContext, lineItem => lineItem[alias]);
export const useLineItemSelector = selector => useContextSelector(LineItemContext, selector);

export default LineItemContext;
